

<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RevisarBitacora">Revisión Bitácora de {{unidad}}</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Revisión Bitácora de {{unidad}}</span>
         

          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad v-on:click=usuario() readonly>
             <b-container fluid class="p-4 bg-dark">
  <b-row>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.foto1antes"></b-img><p style="color:WHITE">FOTO ANTES 1</p></b-col>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.foto2antes"></b-img><p style="color:WHITE">FOTO ANTES 2</p></b-col>
   <div class="w-100"></div>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.foto1despues"></b-img><p style="color:WHITE">FOTO DESPUÉS 1</p></b-col>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.foto2despues"></b-img><p style="color:WHITE">FOTO DESPUÉS 2</p></b-col>
    
  </b-row>
</b-container> 
            <p class="text-break font-weight-bold">
             1. Fecha:  {{formEditar.fecha}} <br>
             2. Identificador: {{formEditar.identificador}} <br>
             3. Descripción: {{formEditar.descripcion}} <br>
             4. Ubicación: {{formEditar.ubicacion}} <br>
             5. Tipo: {{formEditar.tipo}} <br>
             6. Resultado: {{formEditar.resultado}}  <br> 
             7. Departamento: {{formEditar.departamento}} <br>
             8. Comentarios: <br>
             <b-form-textarea
      id="textarea"
      v-model="formEditar.comentarios"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
      readonly="true"
    ></b-form-textarea>
             9. Personal:  <br>
    <b-form-textarea
      id="textarea"
      v-model="formEditar.personal"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
      readonly="true"
    ></b-form-textarea>
             10. Materiales: <br>
             <b-form-textarea
      id="textarea"
      v-model="formEditar.material"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
      readonly="true"
    ></b-form-textarea>
    11. Extra: <br>
             <b-form-textarea
      id="textarea"
      v-model="formEditar.extra"
      placeholder="Enter something..."
      rows="3"
      max-rows="6"
      readonly="true"
    ></b-form-textarea>
             
             12. Etiquetas: {{formEditar.etiquetas}} <br>
             
            
             
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <input type="submit" value="Registrar" :class="boton">
                           
        </div>
            </form>
       

    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado del día <br>
    <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarPesosBovinos from '../mixins/eliminarPesosBovinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'RevisarBitacora',  
  data () {
    return {
        mainProps: { blank: true, width: 150, height: 150, class: 'm1' },
        value:1,
         boton:'btn blue disabled',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        corregir:'',
        canal:'',
        serie:'',
        idver:'',
        formEditar:{},
      columns:[
        {
          label:'id',
          field:'id',
            hidden:true
        },
        {
          label:'Identificador',
          field:'identificador',
         },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Ubicación',
          field:'ubicacion'
        },
        {
          label:'Tipo',
          field:'tipo'
        },
        {
          label:'Departamento',
          field:'departamento'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
     ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanal.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    getId(){
           //this.usuario()

            const id = this.idver
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBitacora1.php?id='+id)
            
                .then(response=>{
                   
                    this.formEditar = response.data
                  
                    //this.selected=this.formEditar.perfil
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarPesosBovinos(params.row.id)
         this.ajax()
         }
         else{
            this.idver= params.row.id
           setTimeout(() => {  this.getId(); }, 500)
        this.ajax()
         }
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajaxdelay(){
     setTimeout(() => {  this.ajax(); }, 2500)
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = '2020-02-02'
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBitacora.php?fecha='+fecha+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },
    usuario(){
       // this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    },
    editar(){
      if(this.boton == 'btn blue disabled'){

            }
            else{
            //this.usuario()
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarPeso.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       this.ajax()
                    this.ticketIncremento()
                        document.getElementById("peso").value=""
                      document.getElementById("peso").focus()
                       //swal('El registro fue editado')
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El registro no pudo ser editado'+res.data)
                    }
                })
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    
    setTimeout(() => {  this.usuario(); }, 500)
    setTimeout(() => {  this.ajax(); }, 1500)
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarPesosBovinos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RevisarBitacora.vue